/**
 * `?next=` after a login: only a path on this site is followed. Anything that could leave it (another
 * host, `//host`, `/\host`, a scheme, control characters) is refused and the map is used instead.
 */
export function safeNext(raw: string | null | undefined): string | null {
  if (!raw || raw.length > 2000) return null;
  // a single leading slash: not "//host" (protocol-relative), not "/\host" (browsers read it as "//")
  if (!raw.startsWith("/") || raw.startsWith("//") || raw.startsWith("/\\")) return null;
  // control characters, tabs and newlines are stripped by URL parsers: "/\t/host" must not slip through
  if (/[\u0000-\u001f\u007f\\]/.test(raw)) return null;
  try {
    const base = "http://same-site.invalid";
    const u = new URL(raw, base);
    if (u.origin !== base) return null;
    return u.pathname + u.search + u.hash;
  } catch {
    return null;
  }
}

/** The login page for a guarded page: back to `path` once signed in. */
export const loginUrl = (locale: string, next?: string): string =>
  `/${locale}/login${next ? `?next=${encodeURIComponent(next)}` : ""}`;
